import api from "@/apis/CustomerAPI";
import Crud from "./crud-base";
import httpClient from "@/apis/base/axios-httpclient";
var crud = new Crud("customer", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "code",
      code: "name",
      name: "name",
    },
  },
  datas: [],
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * customer Load danh sách
   */
  async load(context, payload) {
    let res = null;
    try {
      context.commit("updateLoading", true);
      res = await api.getList(payload || {});
    } finally {
      context.commit("updateLoading", false);
    }

    if (res && !payload.notUpdateItem) {
      context.commit("setItems", { result: res, payload: payload });
    } else {
      context.commit("setDatas", { result: res, payload: payload });
    }

    return res;
  },
};
const mutations = {
  ...crud.mutations,
  setDatas(state, data) {
    if (data.result) {
      if (data.result.length > 0) {
        state.datas.removeAll();
        state.datas = data.result;
        //state.dataTotal = resultValue;
      }

      //   case "Total":
      //     state.dataTotal = resultValue;
      //     break;
      //   case "Empty":
      //     state.dataEmpty = resultValue;
      //     break;
      //   case "Summary":
      //     state.dataSummary = resultValue;
      //     break;
      // }
    }

    // state.items.removeAll();
    // state.items.append(res.PageData);
    // if (!res.payload || !res.payload.skip) {
    //   state.total = res.Total;
    //   state.empty = res.Empty;
    // }
  },
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
